import { render, staticRenderFns } from "./TransportadorEdicao.vue?vue&type=template&id=7bd7ab22"
import script from "./TransportadorEdicao.vue?vue&type=script&lang=js"
export * from "./TransportadorEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports